<!-- @format -->

<div data-cy="open-university-assessment-items-and-course-unit-realisations">
  @if (showCourseUnitRealisationInfoText) {
    <p class="sis-guidance sis-guidance__primary sis-pb-sm">
      {{ "OPENUNIVERSITY.STUDY_RIGHTS.ASSESSMENT_ITEM.GUIDANCE" | translate }}
    </p>
  }

  <div role="heading" class="fudis-heading__xs" [attr.aria-level]="7">
    {{ "OPENUNIVERSITY.STUDY_RIGHTS.ASSESSMENT_ITEM.MAX_NUMBER_OF_ENROLMENTS" | transloco }}
  </div>

  @if (hasNoEnrolmentLimit()) {
    <p>
      {{ "OPENUNIVERSITY.STUDY_RIGHTS.ASSESSMENT_ITEM.NO_LIMIT" | transloco }}
    </p>
  }

  @if (!hasNoEnrolmentLimit()) {
    <sis-description-list-compact [columnCount]="1">
      <dl>
        <ng-template #compactListItem>
          <dt class="sis-label colon">{{ "OPENUNIVERSITY.STUDY_RIGHTS.ASSESSMENT_ITEM.TOTAL" | transloco }}</dt>
          <dd class="sis-value">{{ remainingEnrolmentCounts?.total }}</dd>
        </ng-template>
        <ng-template #compactListItem>
          <dt class="sis-label colon">{{ "OPENUNIVERSITY.STUDY_RIGHTS.ASSESSMENT_ITEM.USED" | transloco }}</dt>
          <dd class="sis-value">{{ remainingEnrolmentCounts?.used }}</dd>
        </ng-template>
        <ng-template #compactListItem>
          <dt class="sis-label colon">{{ "OPENUNIVERSITY.STUDY_RIGHTS.ASSESSMENT_ITEM.REMAIN" | transloco }}</dt>
          <dd class="sis-value">{{ remainingEnrolmentCounts?.remain() }}</dd>
        </ng-template>
      </dl>
    </sis-description-list-compact>
  }
  <br />

  @if (!courseUnitRealisations?.length) {
    <p class="guidance">
      {{ "OPENUNIVERSITY.STUDY_RIGHTS.ASSESSMENT_ITEM.NO_CURS" | translate }}
    </p>
  }

  <ul class="no-list-style-type">
    @for (courseUnitRealisation of courseUnitRealisations | slice: 0 : showLimit; track entityId($index, courseUnitRealisation)) {
      <li class="sis-mb-xs" data-cy="open-university-course-unit-realisation">
        @if (componentType === "STAFF") {
          <a
            fudisLink
            [href]="'/teacher/role/staff/teaching/course-unit-realisations/view/' + courseUnitRealisation.id + '/information/basicinfo'"
            [external]="true"
            class="course-unit-realisation-title"
            [title]="$any(courseUnitRealisation) | courseUnitRealisationFullName | localizedString"></a>
        }
        @if (componentType === "STUDENT") {
          <ng-container>{{ $any(courseUnitRealisation) | courseUnitRealisationFullName | localizedString }}</ng-container>
        }
        <hr class="sis-hr" aria-hidden="true" />
      </li>
    }
  </ul>

  <div class="show-all">
    @if (courseUnitRealisations?.length > showLimit) {
      <sis-button [link]="true" (clicked)="onClickShowAll()" data-cy="show-all-course-unit-realisations-button">
        {{ "OPENUNIVERSITY.STUDY_RIGHTS.ASSESSMENT_ITEM.N_OTHERS" | translate: { others: courseUnitRealisations.length - showLimit } }}
      </sis-button>
    }
    @if (!showLimit && courseUnitRealisations?.length > DEFAULT_SHOW_LIMIT) {
      <sis-button [link]="true" (clicked)="onClickShowLess()" data-cy="show-less-course-unit-realisations-button">
        {{ "OPENUNIVERSITY.STUDY_RIGHTS.ASSESSMENT_ITEM.SHOW_LESS" | translate }}
      </sis-button>
    }
  </div>
</div>
